export default {
  namespaced: true,

  getters: {
    // provincesByRegion: (state, getters, { apis: { provinces } }) => regionId => {
    //   let copy = [...provinces]
    //   if (regionId) copy = copy.filter(({ FK_Regione: rId }) => Number(regionId) === Number(rId))
    //   return copy.map(({ label, value }) => ({ label, value }))
    // }
    provincesByRegions: (_, __, { apis: { provinces } }) => regions => {
      let copy = [...provinces]
      if ((regions || []).length > 0) copy = copy.filter(({ FK_Regione: rId }) => regions.includes(Number(rId)))
      return copy.map(({ label, value }) => ({ label, value }))
    },
  },
}
